import { Bot, Sparkles } from 'lucide-react';
import { CopilotDrawerFlyout } from './CopilotDrawerFlyout.jsx';
import { cn } from '../../lib/utils.js';

export function CopilotFloatingFab({
  open,
  onOpenChange,
  tenant,
  className = '',
  ...props
}) {
  return (
    <>
      {/* Floating Action Trigger Button */}
      <div
        data-testid="copilot-floating-fab"
        data-copilot-variant="floating_fab"
        className={cn('fixed bottom-6 right-6 z-40 flex items-center', className)}
      >
        <button
          type="button"
          onClick={() => onOpenChange && onOpenChange(!open)}
          aria-label="ALWIS Fachassistent öffnen"
          className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[var(--primary)] text-[var(--primary-foreground,#ffffff)] shadow-xl transition-all duration-200 hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-[var(--ring)] cursor-pointer"
        >
          {/* Subtle pulse animation indicator */}
          <span className="absolute -top-0.5 -right-0.5 flex h-3.5 w-3.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-3.5 w-3.5 bg-emerald-500 border-2 border-white" />
          </span>

          <Bot className="h-7 w-7 transition-transform group-hover:rotate-6" />

          {/* Hover Tooltip Pill */}
          <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-lg border border-[var(--border)] bg-white px-3 py-1.5 text-xs font-bold text-[var(--foreground)] shadow-md group-hover:flex items-center gap-1.5">
            <Sparkles className="h-3.5 w-3.5 text-[var(--primary)]" />
            <span>ALWIS Assistent</span>
          </span>
        </button>
      </div>

      {/* Slide-In Drawer when open */}
      <CopilotDrawerFlyout
        open={open}
        onOpenChange={onOpenChange}
        tenant={tenant}
        {...props}
      />
    </>
  );
}
